import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Helmet from "react-helmet";
import { load, save, confirm } from "actions/hdfActions";
import { getInitialValues } from "reducers/hdfReducer";
import AxaHDF from "./form";
import { getHDFId } from "../utils";

const AxaHdfPage = ({ location, load, planYearId, enrolmentKey, ...props }) => {
  const hdfId = getHDFId(location);

  useEffect(() => {
    load(hdfId, planYearId, enrolmentKey);
  }, [hdfId, planYearId, enrolmentKey]);

  return (
    <div>
      <Helmet>
        <link rel="stylesheet" type="text/css" href="/assets/css/hdf/axa.css" />
      </Helmet>

      <AxaHDF {...props} hdfId={hdfId} />
    </div>
  );
};

AxaHdfPage.propTypes = {
  planYearId: PropTypes.string,
  enrolmentKey: PropTypes.string,
  location: PropTypes.object.isRequired,
  load: PropTypes.func.isRequired,
  save: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
};

const mapStateToProps = (
  { hdf: { employeeParticulars }, form },
  {
    match: {
      params: { planYearId, enrolmentKey },
    },
  }
) => ({
  initialValues: getInitialValues(employeeParticulars),
  axaForm: form.axaHdf,
  employeeParticulars,
  planYearId,
  enrolmentKey,
});

const mapDispatchToProps = { load, save, confirm };

export default connect(mapStateToProps, mapDispatchToProps)(AxaHdfPage);



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/Axa/index.js